import {
  Combobox as ComboboxBase,
	ComboboxContent,
	ComboboxInput,
	ComboboxItem,
	ComboboxTrigger,
} from "@/components/shadcn/combobox";
import { createSignal } from "solid-js";

export function Combobox(props) {

  const [text, setText] = createSignal('');

  const onInput = (item) => {
    if (!item) {
      return;
    }

    setText(item.text);

    if (props.onChange) {
      props.onChange(item.value);
    }
  }

  return (
    <ComboboxBase
        class={props.class}
        value={{ value: props.value, text: text(), disabled: false }}
        triggerMode="input"
        closeOnSelection={true}
        optionValue="value"
        optionTextValue="value"
        optionLabel="text"
			  optionDisabled="disabled"
        onChange={onInput}
        options={props.options}
        itemComponent={(innerProps) => (
          <ComboboxItem item={innerProps.item} class="text-xs">{innerProps.item.rawValue.text}</ComboboxItem>
        )}
      >
        <ComboboxTrigger>
          <ComboboxInput class="text-sm" />
        </ComboboxTrigger>
        <ComboboxContent />
      </ComboboxBase>
  );
}
